function toCamelCase(value = '') {
  const parts = value
    .split(/[^A-Za-z0-9]+/)
    .filter(Boolean)
    .map(part => part.toLowerCase());
  if (!parts.length) {
    return '';
  }
  return parts[0] + parts.slice(1).map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('');
}

function sanitizeForKey(value = '') {
  return value.replace(/[^A-Za-z0-9]+/g, '');
}

export function translateFieldLabel(fields, key, t) {
  const fallback =
    (fields && fields[key]) || (typeof t === 'function' ? key : '');
  if (!t) {
    return fallback;
  }
  const fallbackKey = sanitizeForKey(fallback);
  const camelFallback = toCamelCase(fallback);
  const candidates = [
    `fieldLabels.${key}`,
    `fieldLabels.${key.replace(/\s+/g, '')}`,
    `fieldLabels.${toCamelCase(key)}`,
    fallbackKey ? `fieldLabels.${fallbackKey}` : null,
    camelFallback ? `fieldLabels.${camelFallback}` : null,
  ];
  for (const candidate of candidates) {
    if (!candidate) continue;
    const translated = t(candidate, { defaultValue: candidate });
    if (translated !== candidate) {
      return translated;
    }
  }
  return fallback;
}

export function translateFieldOptions(fieldOptions, t) {
  return fieldOptions.map(option => {
    const label = translateFieldLabel(
      { [option.value]: option.label || option.value },
      option.value,
      t
    );
    return {
      ...option,
      label,
    };
  });
}

export function translateCountryOptions(countryOptions, t, language = 'en') {
  let displayNames = null;
  try {
    displayNames = new Intl.DisplayNames([language], { type: 'region' });
  } catch (error) {
    displayNames = null;
  }

  const translated = countryOptions.map(option => {
    const isIntlOption = option.value === 'INTL';
    let localized = option.name || option.label;
    if (!isIntlOption && displayNames) {
      try {
        const resolved = displayNames.of(option.value);
        if (resolved) {
          localized = resolved;
        }
      } catch (error) {
        // DisplayNames couldn't resolve this code (e.g. custom values). Fallback to provided label.
      }
    }
    if (!t) {
      return { ...option, label: localized };
    }
    const key = `countries.${option.value}`;
    const label = t(key, localized);
    return { ...option, label };
  });

  const intlIndex = translated.findIndex(option => option.value === 'INTL');
  let intlOption = null;
  if (intlIndex > -1) {
    intlOption = {
      ...translated[intlIndex],
      label: t ? t('countries.INTL', translated[intlIndex].label) : translated[intlIndex].label,
    };
  }

  const others = translated.filter(option => option.value !== 'INTL');
  others.sort((a, b) => a.label.localeCompare(b.label));

  return intlOption ? [intlOption, ...others] : others;
}

export function translateCountryLabel(code, t, language = 'en', fallback = '') {
  if (!code) {
    return fallback;
  }
  let displayNames = null;
  try {
    displayNames = new Intl.DisplayNames([language], { type: 'region' });
  } catch (error) {
    displayNames = null;
  }
  let localized = fallback;
  if (displayNames) {
    try {
      localized = displayNames.of(code) || fallback;
    } catch (error) {
      localized = fallback;
    }
  }
  if (t) {
    return t(`countries.${code}`, localized || code);
  }
  return localized || code;
}

